@if (isLoading()) {
  <ngx-skeleton-loader [theme]="{ height: '100%', display: 'flex', margin: 0 }" />
} @else {
  @if (highchartOptions(); as options) {
    <highcharts-chart
      class="w-full h-full block"

      [options]="options"
    />
  }
}
